import $ from 'jquery';
import plugin from '@core/plugins/lib';
import { onAvailable } from '@core/plugins/lib/selectors';

const ELEMENT_SELECTOR = '[data-cart-quantity]';
const PLUGIN_NAME = 'CartQuantity';

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		System.import(/* webpackChunkName: "plugin--cart-quantity" */ './cart-quantity').then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/cart-quantity/index.js